import { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import {
  useGlobalStateSelector,
  words,
  stateKeysToSetAddress,
  stateKeysToSetUserName,
} from './globalState';
import { ClipboardCopyButton, TextArea2, TextLine3 } from './UtilComponents';
import { handleClickLogin } from './login';
import {
  handleClickMpurse,
  indicateSessions,
  indicateKeyPairs,
  walletsAvailable,
  getValidKeyPairs,
  getActualSubAddresses,
  getParentAddressFromSubAddress,
  formatToSingleTextRecord,
} from './keysAndSigning';
import { writeNdefRecordsOnNfc } from './utils';
import { useNfcrwWrite } from './nativeAppHooks';
import { notifyNativeAppWriteResult } from './nativeApp';
import { NativeAppWriteButton } from './NativeAppUI';
import iconQr from './image/qr_code_2_FILL0_wght400_GRAD0_opsz24.svg';
import iconCheck from './image/check_24dp_FILL0_wght400_GRAD0_opsz24.svg';
import iconAddress from './image/slab_serif_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconLoginList from './image/patient_list_FILL0_wght400_GRAD0_opsz48.svg';
import iconMpurse from './image/mpurse.png';
import iconKeyCard from './image/playing_cards_FILL0_wght400_GRAD0_opsz24.svg';
import iconKeyPool from './image/key_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconPlus from './image/add_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';

// SELECT SECRET POPUP ; type: 'selectSecretPopup'
function SelectSecretPopup(props) {
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  const popup = useGlobalStateSelector( ({ state }) => state.popup[popupLayer] ?? {} );
  const user = useGlobalStateSelector( ({ state }) => state.user );
  const language = useGlobalStateSelector( ({ state }) => state.language ?? 'english' );
  const active = useGlobalStateSelector( ({ state }) => state.active ?? {} );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const secretRecords = popup.body.secretRecords;
  const resolve = popup.body.resolve;
  const reject = popup.body.reject; // eslint-disable-line no-unused-vars
  const qr = popup.body.qr;

  let qrButtonDummy;

  if (qr === true) {
    qrButtonDummy =
    <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
    </button>
  }

  const title =
  <div className='widthMax'>
    {/* PC */}
    <div className='visibleMiddleOrMore boxMonacotto1 margin0p5' >
      <div className='marginSide1 widthMin25' >
        { words.masterAddresses[language] }
      </div>
      <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
      </button>
      { qrButtonDummy }
    </div>
    {/* SP */}
    <div className='visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' >
      <div className='textCenter' >
        { words.masterAddresses[language] }
      </div>
    </div>
  </div>

  const records = secretRecords.map( secretRecord => {
    const { address } = secretRecord;
    const userName = user[address]?.basicInformation?.userName;

    const selectButton =
    <button className='button1' tabindex='0'
      onClick={ () => {
        resolve(secretRecord);
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
      }}
    >
      <img className='size2x2' src={iconCheck} alt='' />
    </button>

    let qrButton;
    if (qr === true) {
      qrButton =
      <button className='button1' tabindex='0'
        onClick={ () => {
          const popup = {
            type: 'displayQrPopup',
            body: {
              data: address,
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <img className='size2x2' src={iconQr} alt='' />
      </button>
    }

    // アクティブカラー

    let activeColor = '';

    if ( address === active.addressMain || address === active.parent ) {
      activeColor = ' backgroundColorPinkPale';
    }

    return (
      <div className=''>
        {/* PC */}
        <div className={'visibleMiddleOrMore boxMonacotto1 margin0p5' + activeColor} >
          <div className='flexColumn justifyContentCenter alignItemsCenter marginSide1 widthMin25' >
            <div>
              { userName }
            </div>
            <div>
              { address }
            </div>
          </div>
          { selectButton }
          { qrButton }
        </div>
        {/* SP */}
        <div className={'visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' + activeColor} >
          <div className='flexColumn justifyContentCenter alignItemsCenter textCenter' >
            <div>
              { userName }
            </div>
            <div>
              { address }
            </div>
          </div>
          { selectButton }
          { qrButton }
        </div>
      </div>
    );
  });


  return (
    <div className=''>
      {/* PC */}
      <div className='visibleMiddleOrMore flexColumn alignItemsCenter'>
        <div className='flexColumn alignItemsCenter'>
          { title }
        </div>
        <div className='flexColumn alignItemsCenter'>
          { records }
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess flexColumn widthMax'>
        <div className='flexColumn alignItemsCenter widthMax'>
          { title }
        </div>
        <div className='flexColumn alignItemsCenter widthMax'>
          { records }
        </div>
      </div>
    </div>
  );
}

// SELECT ADDRESS FROM KEYPOOL POPUP ; type: 'selectAddressFromKeypoolPopup'
function SelectAddressFromKeypoolPopup(props) {
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  const popup = useGlobalStateSelector( ({ state }) => state.popup[popupLayer] );
  const stateKeysToSetAddress = popup.body.stateKeysToSetAddress;
  const stateKeysToSetUserName = popup.body.stateKeysToSetUserName;
  const qr = popup.body.qr;
  const subAddressEnabled = popup.body.subAddressEnabled;
  const loginEnabled = popup.body.loginEnabled;
  const setConfigure = popup.body.setConfigure;
  const keyPairs = useGlobalStateSelector( ({ state }) => state.keyPairs );
  const subAddresses = useGlobalStateSelector( ({ state }) => state.subAddresses );
  const user = useGlobalStateSelector( ({ state }) => state.user );
  const active = useGlobalStateSelector( ({ state }) => state.active );
  const language = useGlobalStateSelector( ({ state }) => state.language || 'english' );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  const subAddressSet = new Set(
    Object.keys(subAddresses)
    .flatMap( (addressMain) => getActualSubAddresses({ subAddresses, addressMain }) )
  );
  const masterAddressSet = new Set(Object.keys(subAddresses));
  const keypoolAddresses = Object.keys(keyPairs)
  .filter( (address) => keyPairs[address].expiration >= Date.now() )
  .filter( (address) => masterAddressSet.has(address) || !subAddressSet.has(address) );

  let qrButtonDummy;
  if (qr === true) {
    qrButtonDummy =
    <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
    </button>
  }

  let subAddressesButtonDummy;
  if (keypoolAddresses.some( (address) => getActualSubAddresses({ subAddresses, addressMain: address }).length >= 1 )) {
    subAddressesButtonDummy =
    <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
    </button>
  }

  const wifButtonDummy =
  <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
  </button>

  const title =
  <div className='widthMax'>
    {/* PC */}
    <div className='visibleMiddleOrMore boxMonacotto1 margin0p5' >
      <div className='marginSide1 widthMin25' >
        { words.keypool[language] }
      </div>
      <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
      </button>
      <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
      </button>
      { qrButtonDummy }
      { wifButtonDummy }
      { subAddressesButtonDummy }
    </div>
    {/* SP */}
    <div className='visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' >
      <div className='textCenter' >
        { words.keypool[language] }
      </div>
    </div>
  </div>

  const records = keypoolAddresses.map( address => {
    const userName = user[address]?.basicInformation?.userName;

    const selectButton =
      <button className='button1' tabindex='0'
        onClick={ () => {
          for (const keys of stateKeysToSetAddress) {
            dispatch({ type: 'setStateMultiLayers', keys: keys, value: address });
          }

          for (const keys of stateKeysToSetUserName) {
            dispatch({ type: 'setStateMultiLayers', keys: keys, value: userName ?? '' });
          }

          if (stateKeysToSetAddress.some(keys => keys.length === 2 && keys[0] === 'active' && keys[1] === 'addressMain')) {
            const parentAddress = getParentAddressFromSubAddress({ subAddresses, subAddress: address });
            dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: parentAddress });
          }

          // 基本情報をconfigureにセット
          if (
            setConfigure === true &&
            user[address]?.basicInformation !== undefined &&
            user[address]?.basicInformation !== null
          ) {
            dispatch({ type: 'setState', key: 'configure', value: user[address].basicInformation });
          }

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
        }}
      >
        <img className='size2x2' src={iconCheck} alt='' />
      </button>

    let subAddressesButton;
    if (subAddressEnabled && getActualSubAddresses({ subAddresses, addressMain: address }).length >= 1) {
      subAddressesButton =
      <button className='button1' tabindex='0'
        onClick={ () => {
          const popup = {
            type: 'selectSubAddressPopup',
            body: {
              addressMain: address,
              stateKeysToSetAddress,
              stateKeysToSetUserName,
              qr: true,
              loginEnabled,
              setConfigure,
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <img className='size2x2' src={iconPlus} alt='sub addresses' />
      </button>
    }
    else {
      subAddressesButton =
      <button className='dummyPadButton1 backgroundColorTransparent ' disabled={true} >
      </button>
    }

    let qrButton;
    if (qr === true) {
      qrButton =
      <button className='button1' tabindex='0'
        onClick={ () => {
          const popup = {
            type: 'displayQrPopup',
            body: {
              data: address,
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <img className='size2x2' src={iconQr} alt='' />
      </button>
    }

    const wifButton =
    <button className='button1' tabIndex='0'
      onClick={ () => {
        const closeConfirmationPopup = () => {
          dispatch({
            type: 'setStateMultiLayers',
            keys: ['popup', popupLayerNext],
            value: { type: null, body: null },
          });
        };
        const openDisplayWifPopup = () => {
          const wif = keyPairs[address].keyPair.toWIF();

          dispatch({
            type: 'setStateMultiLayers',
            keys: ['popup', popupLayerNext],
            value: {
              type: 'displayWifPopup',
              body: { wif, address },
            },
          });
        };
        const popup = {
          type: 'confirmationPopup',
          body: {
            message: words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[language],
            buttonFaceOk: words.ok[language],
            buttonFaceCancel: words.cancel[language],
            callbackOk: openDisplayWifPopup,
            callbackCancel: closeConfirmationPopup,
          },
        };

        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
      }}
    >
      <img className='size2x2' src={iconKeyPool} alt='WIF' />
    </button>

    // アクティブカラー

    let activeColor = '';

    if (address === active.parent) {
      activeColor = ' backgroundColorMonacottoPale';
    }

    if (address === active.addressMain) {
      activeColor = ' backgroundColorPinkPale';
    }

    return (
      <div className=''>
        {/* PC */}
        <div className={'visibleMiddleOrMore boxMonacotto1 margin0p5' + activeColor} >
          <div className='flexColumn justifyContentCenter alignItemsCenter marginSide1 widthMin25' >
            <div>
              { userName }
            </div>
            <div>
            { address }
            </div>
          </div>
          { selectButton }
          <ClipboardCopyButton text={address} />
          { qrButton }
          { wifButton }
          { subAddressesButton }
        </div>
        {/* SP */}
        <div className={'visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' + activeColor} >
          <div className='flexColumn justifyContentCenter alignItemsCenter textCenter' >
            <div>
              { userName }
            </div>
            <div>
              { address }
            </div>
          </div>
          <div className='flexRow justifyContentCenter alignItemsCenter ' >
            { selectButton }
            <ClipboardCopyButton text={address} />
            { qrButton }
            { wifButton }
            { subAddressesButton }
          </div>
        </div>
      </div>
    );
  });


  return (
    <div className=''>
      {/* PC */}
      <div className='visibleMiddleOrMore flexColumn alignItemsCenter'>
        <div className='flexColumn alignItemsCenter'>
          { title }
        </div>
        <div className='flexColumn alignItemsCenter'>
          { records }
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess flexColumn widthMax'>
        <div className='flexColumn alignItemsCenter widthMax'>
          { title }
        </div>
        <div className='flexColumn alignItemsCenter widthMax'>
          { records }
        </div>
      </div>
    </div>
  );
}

// DISPLAY WIF POPUP ; type: 'displayWifPopup'
function DisplayWifPopup(props) {
  const popupLayer = props.popupLayer;
  const popup = useGlobalStateSelector( ({ state }) => state.popup[popupLayer] );
  const language = useGlobalStateSelector( ({ state }) => state.language || 'english' );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const hasCamera = useGlobalStateSelector( ({ state }) => state.device?.hasCamera );
  const wif = popup.body.wif;
  const address = popup.body.address;
  const canvasRef = useRef(null);
  const canvasId = `wifQrCodeCanvas-${popupLayer}`;
  const nativeAppAvailable = walletsAvailable({ hasCamera }).includes('nfcNative');

  // iPhone アプリでプレーンテキストを書き込む（2 段）
  const nfcrwWrite = useNfcrwWrite({
    enabled: nativeAppAvailable,
    language,
    source: wif,
    // Web NFC の形で作る（Web NFC の書き込みボタンと同じ）。アプリの形への変換はフックが行う
    buildRecords: async () => formatToSingleTextRecord({ data: wif }),
    onReadyToWrite: () => {
      dispatch({ type: 'setNotification', key: 'notification', value: words.readyToWriteEncryptedData[language] });
    },
    onResult: ({ ok, error }) => notifyNativeAppWriteResult({ dispatch, language, ok, error }),
  });
  const fileName = `WIF-QRCode-${address}.png`;

  const downloadPng = () => {
    const node = canvasRef.current;
    const canvas =
      (node?.tagName === 'CANVAS' ? node : node?.querySelector?.('canvas')) ||
      document.getElementById(canvasId);

    if (!canvas) {
      return;
    }

    const url = canvas.toDataURL('image/png');
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.rel = 'noopener';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  };

  let writeWifOnNfcButton;

  if (walletsAvailable({ hasCamera }).includes('nfc')) {
    const writeWifOnNfc = async () => {
      dispatch({
        type: 'setNotification',
        key: 'notification',
        value: words.touchWithNfcTag[language],
      });

      const records = formatToSingleTextRecord({ data: wif });
      await writeNdefRecordsOnNfc({ dispatch, records, language });
    };

    writeWifOnNfcButton =
    <>
      <div className='widthMax marginTop1'>
        { words.writeInPlainTextToNfc[language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabIndex='0'
        onClick={writeWifOnNfc}
      >
        <div>
          { words.write[language] }
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt='nfc' />
        </div>
      </button>
    </>;
  }

  let writeWifWithNativeAppButton;

  if (nativeAppAvailable) {
    writeWifWithNativeAppButton =
    <NativeAppWriteButton
      nfcrwWrite={nfcrwWrite}
      intent='plain'
      label={words.writeInPlainTextToNfcWithNativeApp[language]}
    />;
  }


  return (
    <div className='flexColumn alignItemsCenter widthMax padding0p5'>
      <div className='widthMax marginTop1'>
        { words.wif[language] }
      </div>
      <QRCodeCanvas
        ref={canvasRef}
        id={canvasId}
        value={wif}
        size={300}
        includeMargin
      />
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabIndex='0'
        onClick={downloadPng}
      >
        { words.download[language] }
      </button>
      <div className='widthMax breakAll marginTop1 padding0p5'>
        { wif }
      </div>
      <ClipboardCopyButton text={wif} />
      { writeWifOnNfcButton }
      { writeWifWithNativeAppButton }
    </div>
  );
}

// SELECT SESSION POPUP ; type: 'selectSessionPopup'
function SelectSessionPopup(props) {
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  const popup = useGlobalStateSelector( ({ state }) => state.popup[popupLayer] );
  const stateKeysToSetAddress = popup.body.stateKeysToSetAddress;
  const stateKeysToSetUserName = popup.body.stateKeysToSetUserName;
  const qr = popup.body.qr;
  const loginEnabled = popup.body.loginEnabled;
  const setConfigure = popup.body.setConfigure;
  const session = useGlobalStateSelector( ({ state }) => state.session );
  // const balance = useGlobalStateSelector( ({ state }) => state.balance );
  const subAddresses = useGlobalStateSelector( ({ state }) => state.subAddresses );
  const user = useGlobalStateSelector( ({ state }) => state.user );
  const active = useGlobalStateSelector( ({ state }) => state.active );
  const language = useGlobalStateSelector( ({ state }) => state.language || 'english' );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  let sessionAddresses = Object.keys(session);

  sessionAddresses = sessionAddresses.filter( address =>
    session[address].expirationOfSession >= Date.now() /* && balance.monaparty[address] !== undefined */
  );

  let qrButtonDummy;
  if (qr === true) {
    qrButtonDummy =
    <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
    </button>
  }

  let subAddressesButtonDummy;
  if (sessionAddresses.some(address => Array.isArray(subAddresses[address]?.subAddresses) && subAddresses[address].subAddresses.length >= 1)) {
    subAddressesButtonDummy =
    <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
    </button>
  }

  const title =
  <div className='widthMax'>
    {/* PC */}
    <div className='visibleMiddleOrMore boxMonacotto1 margin0p5' >
      <div className='marginSide1 widthMin25' >
        { words.loggedInAddress[language] }
      </div>
      <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
      </button>
      <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
      </button>
      { qrButtonDummy }
      { subAddressesButtonDummy }
    </div>
    {/* SP */}
    <div className='visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' >
      <div className='textCenter' >
        { words.loggedInAddress[language] }
      </div>
      {/*
        <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
        </button>
      */}
      {/* qrButtonDummy */}
    </div>
  </div>

  const records = sessionAddresses.map( address => {
    const userName = user[address]?.basicInformation?.userName;

    const selectButton =
      <button className='button1' tabindex='0'
        onClick={ () => {
          for (const keys of stateKeysToSetAddress) {
            dispatch({ type: 'setStateMultiLayers', keys: keys, value: address });
          }

          if (stateKeysToSetAddress.some(keys => keys.length === 2 && keys[0] === 'active' && keys[1] === 'addressMain')) {
            const parentAddress = getParentAddressFromSubAddress({ subAddresses, subAddress: address });
            dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: parentAddress });
          }

          for (const keys of stateKeysToSetUserName) {
            dispatch({ type: 'setStateMultiLayers', keys: keys, value: userName ?? '' });
          }

          // 基本情報をconfigureにセット
          if (
            setConfigure === true &&
            user[address]?.basicInformation !== undefined &&
            user[address]?.basicInformation !== null
          ) {
            dispatch({ type: 'setState', key: 'configure', value: user[address].basicInformation });
          }

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
        }}
      >
        <img className='size2x2' src={iconCheck} alt='' />
      </button>

    let subAddressesButton;
    if (Array.isArray(subAddresses[address]?.subAddresses) && subAddresses[address].subAddresses.length >= 1) {
      subAddressesButton =
      <button className='button1' tabindex='0'
        onClick={ () => {
          const popup = {
            type: 'selectSubAddressPopup',
            body: {
              addressMain: address,
              stateKeysToSetAddress,
              stateKeysToSetUserName,
              qr: true,
              loginEnabled,
              setConfigure,
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <img className='size2x2' src={iconPlus} alt='sub addresses' />
      </button>
    }
    else {
      subAddressesButton =
      <button className='dummyPadButton1 backgroundColorTransparent ' disabled={true} >
      </button>
    }

    let qrButton;
    if (qr === true) {
      qrButton =
      <button className='button1' tabindex='0'
        onClick={ () => {
          const popup = {
            type: 'displayQrPopup',
            body: {
              data: address,
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <img className='size2x2' src={iconQr} alt='' />
      </button>
    }

    // アクティブカラー

    let activeColor = '';

    if (address === active.parent) {
      activeColor = ' backgroundColorMonacottoPale';
    }

    if (address === active.addressMain) {
      activeColor = ' backgroundColorPinkPale';
    }

    return (
      <div className=''>
        {/* PC */}
        <div className={'visibleMiddleOrMore boxMonacotto1 margin0p5' + activeColor} >
          <div className='flexColumn justifyContentCenter alignItemsCenter marginSide1 widthMin25' >
            <div>
              { userName }
            </div>
            <div>
            { address }
            </div>
          </div>
          { selectButton }
          <ClipboardCopyButton text={address} />
          { qrButton }
          { subAddressesButton }
        </div>
        {/* SP */}
        <div className={'visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' + activeColor} >
          <div className='flexColumn justifyContentCenter alignItemsCenter textCenter' >
            <div>
              { userName }
            </div>
            <div>
              { address }
            </div>
          </div>
          <div className='flexRow justifyContentCenter alignItemsCenter ' >
            { selectButton }
            <ClipboardCopyButton text={address} />
            { qrButton }
            { subAddressesButton }
          </div>
        </div>
      </div>
    );
  });


  return (
    <div className=''>
      {/* PC */}
      <div className='visibleMiddleOrMore flexColumn alignItemsCenter'>
        <div className='flexColumn alignItemsCenter'>
          { title }
        </div>
        <div className='flexColumn alignItemsCenter'>
          { records }
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess flexColumn widthMax'>
        <div className='flexColumn alignItemsCenter widthMax'>
          { title }
        </div>
        <div className='flexColumn alignItemsCenter widthMax'>
          { records }
        </div>
      </div>
    </div>
  );
}

// VIEW SESSION POPUP
function ViewSessionPopup(props) {
  const state = useGlobalStateSelector( ({ state }) => state ); const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const popupLayer = props.popupLayer;

  let sessionAddresses = Object.keys(state.session);

  sessionAddresses = sessionAddresses.filter( address =>
    state.session[address].expirationOfSession >= Date.now() && state.balance.monaparty[address] !== undefined
  );

  const title =
  <div className='widthMax'>
    {/* PC */}
    <div className='visibleMiddleOrMore boxMonacotto1 margin0p5' >
      <div className='marginSide1 widthMin25' >
        { words.loggedInAddress[state.language] }
      </div>
      <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
      </button>
    </div>
    {/* SP */}
    <div className='visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' >
      <div className='textCenter' >
        { words.loggedInAddress[state.language] }
      </div>
      <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
      </button>
    </div>
  </div>

  const records = sessionAddresses.map( address =>
    <div className=''>
      {/* PC */}
      <div className='visibleMiddleOrMore boxMonacotto1 margin0p5' >
        <div className='marginSide1 widthMin25' >
          { address }
        </div>
        <button className='button1' tabindex='0'
          onClick={ () => {
            const popup = {
              type: 'displayQrPopup',
              body: {
                data: address,
              },
            };

            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
          }}
        >
          <img className='size2x2' src={iconQr} alt='' />
        </button>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' >
        <div className='textCenter' >
          { address }
        </div>
        <button className='button1' tabindex='0'
          onClick={ () => {
            const popup = {
              type: 'displayQrPopup',
              body: {
                data: address,
              },
            };

            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
          }}
        >
          <img className='size2x2' src={iconQr} alt='' />
        </button>
      </div>
    </div>
  );


  return (
    <div className=''>
      {/* PC */}
      <div className='visibleMiddleOrMore flexColumn alignItemsCenter'>
        <div className='flexColumn alignItemsCenter'>
          { title }
        </div>
        <div className='flexColumn alignItemsCenter'>
          { records }
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess flexColumn widthMax'>
        <div className='flexColumn alignItemsCenter widthMax'>
          { title }
        </div>
        <div className='flexColumn alignItemsCenter widthMax'>
          { records }
        </div>
      </div>
    </div>
  );
}

// SELECT SUB ADDRESS POPUP ; type: 'selectSubAddressPopup'
function SelectSubAddressPopup(props) {
  const popupLayer = props.popupLayer;
  const state = useGlobalStateSelector( ({ state }) => state );
  const popup = useGlobalStateSelector( ({ state }) => state.popup[popupLayer] );
  const stateKeysToSetAddress = popup.body.stateKeysToSetAddress;
  const stateKeysToSetUserName = popup.body.stateKeysToSetUserName;
  const qr = popup.body.qr;
  const loginEnabled = popup.body.loginEnabled;
  const setConfigure = popup.body.setConfigure;
  const addressMain = popup.body.addressMain;
  const subAddresses = useGlobalStateSelector( ({ state }) => state.subAddresses );
  const keyPairs = useGlobalStateSelector( ({ state }) => state.keyPairs );
  const user = useGlobalStateSelector( ({ state }) => state.user );
  const active = useGlobalStateSelector( ({ state }) => state.active );
  const language = useGlobalStateSelector( ({ state }) => state.language || 'english' );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const subAddressList = getActualSubAddresses({ subAddresses, addressMain });

  let qrButtonDummy;

  if (qr === true) {
    qrButtonDummy =
    <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
    </button>
  }

  const title =
  <div className='widthMax'>
    {/* PC */}
    <div className='visibleMiddleOrMore boxMonacotto1 margin0p5' >
      <div className='marginSide1 widthMin25' >
        { words.subAddresses[language] }
      </div>
      <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite ' disabled={true} >
      </button>
      { qrButtonDummy }
    </div>
    {/* SP */}
    <div className='visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' >
      <div className='textCenter' >
        { words.subAddresses[language] }
      </div>
    </div>
  </div>

  const records = subAddressList.map( address => {
    const userName = user[address]?.basicInformation?.userName;
    let qrButton;

    const selectButton =
    <button className='button1' tabindex='0'
      onClick={ async () => {
        let activeAddress = null;

        if (
          loginEnabled &&
          (user[address]?.basicInformation === undefined || (user[address]?.certificatedBy !== 'signature' && user[address]?.certificatedBy !== 'sessionId'))
        ) {
          const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs });
          const keyPair = keyPairsInPool[address]?.keyPair;

          if (keyPair !== undefined) {
            ({ activeAddress = null } = (await handleClickLogin({
              dispatch,
              popupLayer,
              keyPairs: [ keyPair ],
              keyPairsInPoolAll: keyPairs,
              sessionToOverride: {},
              login: state.login,
              walletType: state.walletType,
              session: state.session,
              marginOfSessionTime: state.marginOfSessionTime,
              assetInfos: state.assetInfo,
              monacards: state.monacard,
              network: state.networkMona,
              clientParameters: state.config.clientParameters,
              language,
            })));
          }
        }
        else {
          for (const keys of stateKeysToSetAddress) {
            dispatch({ type: 'setStateMultiLayers', keys: keys, value: address });
          }

          for (const keys of stateKeysToSetUserName) {
            dispatch({ type: 'setStateMultiLayers', keys: keys, value: userName ?? '' });
          }

          // 基本情報をconfigureにセット
          if (
            setConfigure === true &&
            user[address]?.basicInformation !== undefined &&
            user[address]?.basicInformation !== null
          ) {
            dispatch({ type: 'setState', key: 'configure', value: user[address].basicInformation });
          }

          activeAddress = address;
        }

        if (stateKeysToSetAddress.some(keys => keys.length === 2 && keys[0] === 'active' && keys[1] === 'addressMain')) {
          const parentAddress = getParentAddressFromSubAddress({ subAddresses, subAddress: activeAddress });
          dispatch({ type: 'setStateMultiLayers', keys: ['active', 'parent'], value: parentAddress });
        }

        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
      }}
    >
      <img className='size2x2' src={iconCheck} alt='' />
    </button>

    if (qr === true) {
      qrButton =
      <button className='button1' tabindex='0'
        onClick={ () => {
          const popup = {
            type: 'displayQrPopup',
            body: {
              data: address,
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
        }}
      >
        <img className='size2x2' src={iconQr} alt='' />
      </button>
    }

    // アクティブカラー

    let activeColor = '';

    if (address === active.parent) {
      activeColor = ' backgroundColorMonacottoPale';
    }

    if (active.addressMain === address) {
      activeColor = ' backgroundColorPinkPale';
    }

    return (
      <div className=''>
        {/* PC */}
        <div className={'visibleMiddleOrMore boxMonacotto1 margin0p5' + activeColor} >
          <div className='flexColumn justifyContentCenter alignItemsCenter marginSide1 widthMin25' >
            <div>
              { userName }
            </div>
            <div>
            { address }
            </div>
          </div>
          { selectButton }
          <ClipboardCopyButton text={address} />
          { qrButton }
        </div>
        {/* SP */}
        <div className={'visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' + activeColor} >
          <div className='flexColumn justifyContentCenter alignItemsCenter textCenter' >
            <div>
              { userName }
            </div>
            <div>
              { address }
            </div>
          </div>
          <div className='flexRow justifyContentCenter alignItemsCenter ' >
            { selectButton }
            <ClipboardCopyButton text={address} />
            { qrButton }
          </div>
        </div>
      </div>
    );
  });


  return (
    <div className=''>
      {/* PC */}
      <div className='visibleMiddleOrMore flexColumn alignItemsCenter'>
        <div className='flexColumn alignItemsCenter'>
          { title }
        </div>
        <div className='flexColumn alignItemsCenter'>
          { records }
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess flexColumn widthMax'>
        <div className='flexColumn alignItemsCenter widthMax'>
          { title }
        </div>
        <div className='flexColumn alignItemsCenter widthMax'>
          { records }
        </div>
      </div>
    </div>
  );
}

// ADDRESS SECTION
// deprecated
function AddressSection(props) {
  const state = useGlobalStateSelector( ({ state }) => state ); const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const keys = props.keys;
  let addressSection;

  addressSection =
  <div className='flexRow justifyContentCenter alignItemsCenter '>
    <TextLine3 fieldName='addressSectionAddressMain' keys={keys} face={words.addressMain[state.language]} tooltip='right' />
    <button className='button1'
      onClick={ () => handleClickMpurse(state, dispatch, keys) }
    >
      <img className='size2x2' src={iconAddress} alt='' />
    </button>
    {/*
      <button className='button1'
        onClick={ () =>
          handleClickAddressHistory(state, dispatch, cookies, ['login', 'addressMain'], popupLayer)
        }
      >
        <img className='size2x2' src={iconLoginList} alt='' />
      </button>
    */}
  </div>;

  return addressSection;
}

// SELECT ADDRESS FROM KEYPOOL SECTION
function SelectAddressFromKeypoolSection(props) {
  const popupLayer = props.popupLayer;
  const stateKeys = props.stateKeys;
  const stateKeysToSetAddress = props.stateKeysToSetAddress;
  const stateKeysToSetUserName = props.stateKeysToSetUserName;
  const loginEnabled = props.loginEnabled;
  const setConfigure = props.setConfigure;
  const subAddressEnabled = props.subAddressEnabled;
  const language = useGlobalStateSelector( ({ state }) => state.language || 'english' );

  const selectAddressFromKeypoolButton =
  <div className='flexRow justifyContentCenter alignItemsCenter '>
    <TextLine3 fieldName='selectAddressFromKeypoolButtonAddressMain' keys={stateKeys} face={words.addressMain[language]} tooltip='right' />
    <SelectAddressFromKeypoolButton
      popupLayer={popupLayer}
      stateKeysToSetAddress={stateKeysToSetAddress}
      stateKeysToSetUserName={stateKeysToSetUserName}
      loginEnabled={loginEnabled}
      setConfigure={setConfigure}
      subAddressEnabled={subAddressEnabled}
    />
  </div>;

  return selectAddressFromKeypoolButton;
}

// SELECT ADDRESS FROM KEYPOOL BUTTON
// state.keyPairs に基づいて、ボタンの色が変わるバージョン。
function SelectAddressFromKeypoolButton(props) {
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  const stateKeysToSetAddress = props.stateKeysToSetAddress;
  const stateKeysToSetUserName = props.stateKeysToSetUserName;
  const loginEnabled = props.loginEnabled;
  const setConfigure = props.setConfigure;
  const subAddressEnabled = props.subAddressEnabled;
  const keyPairs = useGlobalStateSelector( ({ state }) => state.keyPairs );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  const selectAddressFromKeypoolButton =
  <button
    className={'button1 ' + indicateKeyPairs({ keyPairs })}
    onClick={ () => {
      const popup = {
        type: 'selectAddressFromKeypoolPopup',
        body: {
          stateKeysToSetAddress,
          stateKeysToSetUserName,
          qr: true,
          loginEnabled,
          setConfigure,
          subAddressEnabled,
        },
      };

      dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
    }}
  >
    <img className='size2x2' src={iconKeyPool} alt='' />
  </button>;


  return selectAddressFromKeypoolButton;
}

// SELECT SESSION BUTTON
// props で stateKeysToSetAddress と stateKeysToSetUserName と extraFunction を受け取れるバージョン。
function SelectSessionButton(props) {
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  const loginEnabled = props.loginEnabled;
  const setConfigure = props.setConfigure;
  const stateKeysToSetAddressArg = props.stateKeysToSetAddress;
  const stateKeysToSetUserNameArg = props.stateKeysToSetUserName;
  const extraFunction = props.extraFunction;
  const session = useGlobalStateSelector( ({ state }) => state.session );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  const selectSessionButton =
  <button
    className={'button1 ' + indicateSessions({ session: session })}
    onClick={ () => {
      const popup = {
        type: 'selectSessionPopup',
        body: {
          stateKeysToSetAddress: stateKeysToSetAddressArg ?? stateKeysToSetAddress,
          stateKeysToSetUserName: stateKeysToSetUserNameArg ?? stateKeysToSetUserName,
          qr: true,
          loginEnabled,
          setConfigure,
        },
      };

      dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });

      if (extraFunction !== undefined && extraFunction !== null) {
        extraFunction();
      }
    }}
  >
    <img className='size2x2' src={iconLoginList} alt='' />
  </button>;


  return selectSessionButton;
}

// SESSION TITLE
function SessionTitle() {
  const state = useGlobalStateSelector( ({ state }) => state );

  return (
    <div className='widthMax'>
      {/* PC */}
      <div className='visibleMiddleOrMore boxMonacotto1 margin0p5' >
        <div className='marginSide1 widthMin25' >
          { words.loggedInAddress[state.language] }
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' >
        <div className='textCenter' >
          { words.loggedInAddress[state.language] }
        </div>
      </div>
    </div>
  );
}

// SESSION RECORD
function SessionRecord(props) {
  const record = props.record;

  return (
    <div className=''>
      {/* PC */}
      <div className='visibleMiddleOrMore boxMonacotto1 margin0p5' >
        <div className='marginSide1 widthMin25' >
          { record.address }
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess boxMonacotto1SmallScreen alignItemsCenter' >
        <div className='textCenter' >
          { record.address }
        </div>
      </div>
    </div>
  );
}

// ウォレット選択ボックス
// SELECT WALLET BOX
function SelectWalletBox(props) {
  const keypoolButtonVisible = props.keypoolButtonVisible;
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  let walletSelectBox;

  // ウォレット選択ボタン

  let walletButtons = {};

  walletButtons.keybox =
  <button className={'box3 focusEffect01 riseOut2 ' + (state.walletType === 'keybox' ? 'colorRed borderSelected' : 'borderNone')}
    tabindex='0'
    onClick={ () => {
      dispatch({type: 'setState', key: 'walletType', value: 'keybox'});
    }}
  >
    <div className='paddingTopBottom0p5 ' >
      {words.keybox[state.language]}
    </div>
  </button>;

  walletButtons.mpurse =
  <button className={'box3 focusEffect01 riseOut2 ' + (state.walletType === 'mpurse' ? 'colorRed borderSelected' : 'borderNone')}
    tabindex='0'
    onClick={ () => {
      dispatch({type: 'setState', key: 'walletType', value: 'mpurse'});
    }}
  >
    <div className='paddingTopBottom0p5 ' >
      {words.mpurse[state.language]}
    </div>
  </button>;

  walletButtons.nfc =
  <button className={'box3 focusEffect01 riseOut2 ' + (state.walletType === 'nfc' ? 'colorRed borderSelected' : 'borderNone')}
    tabindex='0'
    onClick={ () => {
      dispatch({type: 'setState', key: 'walletType', value: 'nfc'});
    }}
  >
    <div>
      {words.keyCard[state.language]}
    </div>
    <div>
      {words.nfc[state.language]}
    </div>
  </button>;

  walletButtons.nfcNative =
  <button className={'box3 focusEffect01 riseOut2 ' + (state.walletType === 'nfcNative' ? 'colorRed borderSelected' : 'borderNone')}
    tabindex='0'
    onClick={ () => {
      dispatch({type: 'setState', key: 'walletType', value: 'nfcNative'});
    }}
  >
    <div>
      {words.keyCard[state.language]}
    </div>
    <div>
      {words.nfc[state.language]}
    </div>
  </button>;

  walletButtons.qr =
  <button className={'box3 focusEffect01 riseOut2 ' + (state.walletType === 'qr' ? 'colorRed borderSelected' : 'borderNone')}
    tabindex='0'
    onClick={ () => {
      dispatch({type: 'setState', key: 'walletType', value: 'qr'});
    }}
  >
    <div>
      {words.keyCard[state.language]}
    </div>
    <div>
      {words.bc[state.language]}
    </div>
  </button>;

  const keypoolButton =
  <button className={'box3 focusEffect01 riseOut2 ' + (state.walletType === 'keypool' ? 'colorRed borderSelected' : 'borderNone')}
    tabindex='0'
    onClick={ () => {
      dispatch({type: 'setState', key: 'walletType', value: 'keypool'});
    }}
  >
    <div>
      {words.keypool[state.language]}
    </div>
  </button>;

  const walletButtonsToDisplay = walletsAvailable({ hasCamera: state?.device?.hasCamera }).map( walletType => walletButtons[walletType] );

  if (keypoolButtonVisible) {
    walletButtonsToDisplay.push(keypoolButton);
  }

  // if (walletsAvailable(state).length >= 2 || state.walletType !== walletsAvailable(state)[0]) {
    walletSelectBox =
    <div className='flexRow justifyContentSpaceAround widthMax '>
      { walletButtonsToDisplay }
    </div>;
  // }


  return walletSelectBox;
}

// SIGN ICON
function SignIcon() {
  const state = useGlobalStateSelector( ({ state }) => state );
  let signIcon;

  if (state.walletType === 'mpurse') {
    signIcon = iconMpurse;
  }
  else if (state.walletType === 'nfc' || state.walletType === 'nfcNative') {
    signIcon = iconKeyCard;
  }
  else if (state.walletType === 'qr') {
    signIcon = iconQr;
  }
  else if (state.walletType === 'keypool') {
    signIcon = iconKeyPool;
  }


  if (signIcon !== undefined) {
    return <img className='size2x2 margin0p5' src={signIcon} alt='' />;
  }
  else {
    return null;
  }
}

// HANDLE CLICK VIEW SESSION
function handleClickViewSession(state, dispatch, popupLayer) {
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  let sessionAddresses = Object.keys(state.session);

  // if (addressHistory === undefined) {
  //   addressHistory = [];
  // }

  sessionAddresses = sessionAddresses.filter( address =>
    state.session[address].expirationOfSession >= Date.now() && state.balance.monaparty[address] !== undefined
  );
  const records = sessionAddresses.map( address => <SessionRecord record={ {address} } /> );

  const popup = {
    type: 'generalList',
    body: {
      title: <SessionTitle />,
      options: records,
    },
  };

  dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });

  if (sessionAddresses.length === 0) {
    dispatch({ type: 'setState', key: 'session', value: {} });
  }
}

// MNEMONIC INPUT POPUP ; type: 'mnemonicInputPopup'
function MnemonicInputPopup(props) {
  const popupLayer = props.popupLayer;
  const popup = useGlobalStateSelector( ({ state }) => state.popup[popupLayer] );
  const stateKeys = popup.body.stateKeys;
  const language = useGlobalStateSelector( ({ state }) => state.language || 'english' );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  return (
    <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax marginTop1 '>
        <div className='flexColumn alignItemsFlexStart '>
          <div>
          </div>
          <div>
          </div>
        </div>
        <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabindex='0'
          onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: stateKeys, value: '' }) }
        >
          {words.clear[language]}
        </button>
      </div>
      <div className='widthMax colorRed marginTop1 '>
        { words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[language] }
      </div>
      <TextArea2 fieldName='mnemonicInputMnemonic' keys={stateKeys} face={words.mnemonic[language]}
        outerClass='widthMax' boxClass='box4 width96PC marginTop1 ' textAreaClass='textArea1'
      />
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabindex='0'
        onClick={ () => {
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
        }}
      >
        <div>
          { words.setMnemonic[language] }
        </div>
      </button>
    </div>
  );
}

// WIF INPUT POPUP ; type: 'wifInputPopup'
function WifInputPopup(props) {
  const popupLayer = props.popupLayer;
  const language = useGlobalStateSelector( ({ state }) => state.language );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  return (
    <div className='flexColumn alignItemsCenter borderKOM marginTop1 padding0p5'>
      <div className='flexRow justifyContentFlexEnd alignItemsCenter widthMax marginTop1 '>
        <button className='borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 ' tabIndex='0'
          onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['configure', 'wif'], value: '' }) }
        >
          { words.clear[language] }
        </button>
      </div>
      <div className='widthMax colorRed marginTop1 '>
        { words.pleaseBeCarefulOfYourSurroundingsSoThatOthersCannotSee[language] }
      </div>
      <TextLine3 fieldName='wifInputWif' keys={['configure', 'wif']} face={words.wif[language]} />
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 ' tabIndex='0'
        onClick={ () => {
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
        }}
      >
        { words.setWif[language] }
      </button>
    </div>
  );
}

export {
  SelectSecretPopup,
  SelectWalletBox,
  SignIcon,
  AddressSection,
  SelectSessionButton,
  SelectSessionPopup,
  ViewSessionPopup,
  handleClickViewSession,
  SelectSubAddressPopup,
  MnemonicInputPopup,
  WifInputPopup,
  SelectAddressFromKeypoolSection,
  SelectAddressFromKeypoolButton,
  SelectAddressFromKeypoolPopup,
  DisplayWifPopup,
};
